import { churchOrgTypesForChooser } from '../../../common/src/model.ts';
import { OrgChoice } from './onboarding/org_choice.tsx';

export interface Props {
  visible: boolean;
  onSettingChanged(): void;
  onBack(): void;
}

export const ChooseChurchPage = ({ visible, onSettingChanged, onBack }: Props) => {
  return !visible ? null : (
    <OrgChoice onSettingChanged={onSettingChanged} onBack={onBack} orgTypes={churchOrgTypesForChooser} />
  );
};
